module.exports = __webpack_public_path__ + "img/firebase.7cf7cd65.svg";